<template>
    <price-tag-shell :context="context">
        <div class="pt-column spend">
            <div class="pt-medium">
                <template v-if="editable">
                    {{ tagText('spendAtLeastLabel') }}
                    <price-tag-value v-bind="bindField('spendAmount')" />
                    {{ context.currencySymbol }}
                </template>
                <template v-else>
                    {{
                        tagText('spendAtLeast', {
                            amount: formatMoney(values.spendAmount),
                            currency: context.currencySymbol,
                        })
                    }}
                </template>
            </div>
            <div class="pt-headline">{{ tagText('getItemFor', { product: productName }) }}</div>
            <div class="pt-row spend__price">
                <span class="pt-headline">{{ tagText('just') }}</span>
                <span class="pt-big-number">
                    <price-tag-value v-bind="bindField('price')" />
                </span>
                <span class="pt-currency">{{ context.currencySymbol }}</span>
                <price-tag-discount :percent="firstTier.discountPercent" prefix="-" />
            </div>
            <div v-if="context.isLoyalty" class="pt-medium">
                {{ tagText('withLoyalty', { loyaltyLabel: tagText('loyaltyLabel') }) }}
            </div>
        </div>
    </price-tag-shell>
</template>

<script setup>
import { computed } from 'vue';
import {
    priceTagLayoutProps,
    priceTagLayoutEmits,
    usePriceTagLayout,
} from '@/js/composables/usePriceTagLayout';

const props = defineProps(priceTagLayoutProps);
const emit = defineEmits(priceTagLayoutEmits);

const { bindField, tagText, formatMoney, placeholderText } = usePriceTagLayout(props, emit);

const firstTier = computed(() => props.context.tiers[0] || {});

const productName = computed(() => {
    const { product } = props.context;
    return product ? `${product.brand} ${product.name}`.trim() : placeholderText('name');
});
</script>

<style lang="scss" scoped>
@import '@style/price-tags/price-tag-layout';

.spend {
    text-align: center;
    align-items: center;

    &__price {
        align-items: center;
    }
}
</style>
